import {
  ASSETFORM_FETCHITEM_LOAD,
  ASSETFORM_FETCHITEM_SUCCEED,
  ASSETFORM_FETCHITEM_FAIL,
  ASSETFORM_EDITFORM_CHANGE,
  ASSETFORM_ENTER_RESET,
  ASSETFORM_CREATEITEM_LOAD,
  ASSETFORM_CREATEITEM_SUCCEED,
  ASSETFORM_CREATEITEM_FAIL,
  ASSETFORM_EDITITEM_LOAD,
  ASSETFORM_EDITITEM_SUCCEED,
  ASSETFORM_EDITITEM_FAIL,
  ASSETFORM_DELETEITEM_LOAD,
  ASSETFORM_DELETEITEM_SUCCEED,
  ASSETFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case ASSETFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case ASSETFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case ASSETFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case ASSETFORM_ENTER_RESET:
      return {}
    case ASSETFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case ASSETFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case ASSETFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case ASSETFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case ASSETFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case ASSETFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case ASSETFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case ASSETFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case ASSETFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case ASSETFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}
